import { any2unixtime, isProduction } from 'utils';
export function serverTimeReducer(PRELOAD) {
    const server_time_initial = {
        local: any2unixtime(new Date()),
        server: PRELOAD.server_time + 1,
    };
    const delta = server_time_initial.local - server_time_initial.server;
    if (!isProduction() && Math.abs(delta) > 15) {
        console.error('ERROR! delta time between local machine and server > 15 seconds');
    }
    return (state = server_time_initial) => state;
}
